export default "__VITE_ASSET__0d8bd2f4__"